import { render, staticRenderFns } from "./ElementPhotosModal.vue?vue&type=template&id=6c227d36&scoped=true&"
import script from "./ElementPhotosModal.vue?vue&type=script&lang=js&"
export * from "./ElementPhotosModal.vue?vue&type=script&lang=js&"
import style0 from "./ElementPhotosModal.vue?vue&type=style&index=0&id=6c227d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c227d36",
  null
  
)

export default component.exports